export default function SecretIdDialogController ($scope, $mdDialog, gettextCatalog, selectedItem, secretKind) {
    "ngInject";
    $scope.selectedItem = selectedItem;
    let original_secret_id = selectedItem.secret_id;
    $scope.secretKind = secretKind;
    $scope.status = {info: true};

    $scope.$watch("selectedItem.secret_id", (curr) => {
        if (curr != original_secret_id) {
            $scope.status = {modify: true};
        }
    });

    $scope.closeDialog = function() {
        if($scope.status.alreadyTaken) {
            $scope.selectedItem.secret_id = original_secret_id;
        }
        $mdDialog.hide();
    };

    $scope.copyToClipboard = function() {
        document.getElementById("secret_id_input").select();
        document.execCommand("copy");
        $scope.status = {copied: true};
    };

    $scope.saveSecretID = function () {
        $scope.selectedItem.$update().then(() => {
            $scope.status = {saved: true};
        }).catch(() => {
            $scope.status = {alreadyTaken: true};
        });
    };
    $scope.removeSpacing = function() {
        $scope.selectedItem.secret_id = $scope.selectedItem.secret_id.replace(/\s+/g, "");
    };
}



// WEBPACK FOOTER //
// ./sources/components/secretid/secretid-controller.js